import {stessaLinea} from '../SportMenu/schede';

/**
 * Dalla vetrina alla schedina.
 *
 * In Home NON si compila la schedina: toccando una quota si va alla pagina
 * Sport con quella quota gia' dentro. La schedina vive in SportContainer,
 * che all'avvio rilegge `allBets` da sessionStorage: qui si scrive in quel
 * deposito ESATTAMENTE nella forma che SportContainer scrive da se'
 * (createDefaultAllBetsObject), cosi' c'e' una sola forma e non due.
 *
 * Se la stessa quota c'e' gia', non si duplica: la pagina Sport la mostra
 * accesa e basta.
 */

function leggi() {
  try {
    const grezzo = window.sessionStorage.getItem('allBets');
    const elenco = grezzo ? JSON.parse(grezzo) : [];
    return Array.isArray(elenco) ? elenco : [];
  } catch (e) {
    return [];
  }
}

function nuovoTicketId() {
  // Stesso generatore di SportContainer (uuid v4): qui a mano per non
  // tirarsi dentro la libreria solo per questo.
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    return (c === 'x' ? r : ((r % 4) + 8)).toString(16);
  });
}

/**
 * Mette in schedina un esito di un mercato di una partita.
 *
 * @param partita  come arriva dal feed (id, name, competitionName, date)
 * @param mercato  uno dei suoi `markets` (id, name)
 * @param esito    uno dei suoi `selections` (id, name, odd, sbv)
 * @param segno    cosa c'era scritto sulla casella toccata: 1, X, 2, Over...
 */
export function mettiInSchedina(partita, mercato, esito, segno) {
  const allBets = leggi();
  const quota = {
    id: esito.id,
    sbv: esito.sbv || '',
    oddName: esito.name,
    segno: segno || esito.name,
    value: esito.odd,
  };

  const evento = allBets.find((e) => e.eventId === partita.id);
  if (!evento) {
    allBets.push({
      eventId: partita.id,
      matchName: partita.name,
      competitionName: partita.competitionName || '',
      // La molteplicita' dal palinsesto, come in SportContainer.
      sportId: partita.sportId || '',
      countryId: partita.countryId || '',
      competitionId: partita.competitionId || '',
      molteplicita: partita.molteplicita || 1,
      molteplicitaDa: partita.molteplicitaDa || 'DEFAULT',
      matchDate: partita.date || null,
      markets: [{id: mercato.id, marketName: mercato.name, odds: [quota]}],
    });
  } else {
    const m = evento.markets.find((x) => x.id === mercato.id);
    if (!m) {
      evento.markets.push({id: mercato.id, marketName: mercato.name, odds: [quota]});
    } else if (!m.odds.some((o) => o.id === quota.id && stessaLinea(o.sbv, quota.sbv))) {
      m.odds.push(quota);
    }
  }

  window.sessionStorage.setItem('allBets', JSON.stringify(allBets));
  if (window.sessionStorage.getItem('ticketId') === null) {
    window.sessionStorage.setItem('ticketId', JSON.stringify(nuovoTicketId()));
  }
}

/** Se quella quota e' gia' in schedina: per disegnare la casella accesa. */
export function inSchedina(partita, mercato, esito) {
  const evento = leggi().find((e) => e.eventId === partita.id);
  if (!evento) return false;
  const m = evento.markets.find((x) => x.id === mercato.id);
  return !!m && m.odds.some((o) => o.id === esito.id && stessaLinea(o.sbv, esito.sbv));
}
